// extracted by mini-css-extract-plugin
export default {"pageLayout":"pageLayout_pageLayout__7xMcD","headerContainer":"pageLayout_headerContainer__COd-9","header":"pageLayout_header__2fdBS","title":"pageLayout_title__7eo6E"};